import { api } from '@/api'
import type { ApiPaginationResponse } from '@/api/typings/response.typing'
import type { Service, ServicesFilters } from '@/api/typings/service.typing'

export function getServicesAction(filters: ServicesFilters = {}): Promise<ApiPaginationResponse<Service[]>> {
  const params = new URLSearchParams()

  if (filters.page) {
    params.append('page', String(filters.page))
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '' && key !== 'page') {
      params.append(`filter[${key}]`, String(value))
    }
  })

  const url = `/services?${params.toString()}`

  return api.v2.get<ApiPaginationResponse<Service[]>>(url)
}
